import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import i18n from 'i18next';
export default function CookieNotice() {
    /**
     * Get the value of the given cookie.
     *
     * @param {string} name
     *
     * @return {string}
     */
    function getCookie(name) {
        if(typeof document !== 'undefined') {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
    
            if (parts.length == 2) {
                return parts.pop().split(";").shift();
            }
        }
    }

    /**
     * Create a cookie with the given values.
     *
     * @param {string} name
     * @param {string} value
     * @param {string} days
     *
     * @return {void}
     */
    function createCookie(name, value, days) {
        if (typeof document !== 'undefined') {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
            } else {
                var expires = "";
            }

            document.cookie = name + "=" + value + expires + "; path=/";
        }
    }

    /**
     * Create a new cookie and hide the cookie notice popup.
     *
     * @return {void}
     */
    function closeCookieModal() {
        createCookie('cookie-notice', '1', 90);
        updateVisibility(false);
    }

    var [visible, updateVisibility] = useState(false);

    useEffect(function() {
        if(!getCookie('cookie-notice')) {
            updateVisibility(true);
        }
    }, []);

    return (
        <>
            <Helmet>
                <script async src="https://www.googletagmanager.com/gtag/js?id=G-QSXWVGTRHZ"></script>
                <script>{`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());

                gtag('config', 'G-QSXWVGTRHZ');
                `}
                </script>
                <script>
                {`
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-PSK5N63');
                `}
                </script>
            </Helmet>
            <div class={(visible ? 'block' : 'hidden') + ' fixed bottom-4 right-4 z-30 max-w-xs sm:max-w-md bg-white p-4 border-8 border-gray-100 rounded-2xl shadow-md'}>
                {/*<p>This site uses cookies to store information on your computer. Some are essential to make our site work; others help us to better understand our users. By using the site, you consent to the placement of these cookies. Read our <a href="https://www.airproducts.co.uk/privacy-notice" target="_blank" rel="noopener noreferrer" class="text-primary-blue hover:underline">Legal Notice</a> to learn more.</p>*/}
                <p>{i18n.t('cookietext')}</p>
                <p class="text-right"><button type="button" onClick={() => closeCookieModal()} class="inline-block bg-gray-100 hover:bg-gray-200 py-1 px-4 rounded-full transition-all duration-75 ease-in-out">{i18n.t('cookie_close')}</button></p>
            </div>
        </>
    );
}